<template>
    <div :ref="stepName" style="position:relative">
        <div class="form-header">
            <div class="cookbook-wrapper">
              <img class="ta-magazine" src="/images/fr_multigift_carousel/ta-magazine.png" alt="magazine">
                <div>
                    <h4>Recevez votre <br>
                        <span>e-book gratuit</span></h4>
                    <p>“ 9 recettes <br> irrésistibles <br>
                        avec l’airfryer ”</p>
                </div>
            </div>
            <p>Numéro de GSM</p>
        </div>
        <PhoneForm></PhoneForm>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import PhoneForm from "./PhoneForm";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: { PhoneForm },
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
